var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","border":"1px solid #fff"},style:({ height: _vm.pageHeight }),attrs:{"id":"simulation-report","src":_vm.simulationReportUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }